export default {
  'AUTHENTICATION.BAD_SESSION': '',
  ACCOUNT_NOT_SELECTED: 'Please select at least one account.',
  ACCOUNTS_SELECTION_EXCEEDED: 'You can only select <%=maxLength %> accounts at a time.',
  ACTION_DENIED: 'Items have already been dispositioned.',

  AUTH0001: 'Invalid login credential. Please contact your administrator or customer service.',
  AUTH0002: 'Invalid login credential. Please contact your administrator or customer service.',
  AUTH0003: 'Invalid login credential. Please contact your administrator or customer service.',
  AUTH0004:
    'Your request cannot be processed. Please contact your administrator or customer service.',
  AUTH0005: 'User account locked.  Please contact your administrator or customer service.',
  AUTH0006:
    'Your request cannot be processed. Please contact your administrator or customer service.',
  AUTH0007:
    'Insufficient information to support this request.  Please contact your administrator for assistance.',
  AUTH0008:
    'Insufficient information to support this request.  Please contact your administrator for assistance.',
  AUTH0009:
    'Your request cannot be processed.  Please contact your administrator or customer service.',
  AUTH0010:
    'Maximum attempts reached. User account locked. Please contact your administrator for assistance.',
  AUTH0011:
    'Maximum attempts reached. User account locked. Please contact your administrator for assistance.',
  AUTH0013:
    'Invalid login credential. Please try again or contact your administrator for assistance.',
  AUTH0014: 'Customer not enabled',
  AUTH0015: 'User account locked.  Please contact your administrator or customer service.',
  AUTH0016:
    'Your request cannot be processed. Please contact your administrator or customer service.',
  AUTH0017: 'Both Customer ID and User ID are required',

  BATCH_NOT_FOUND: 'Batch not found.',
  BLANK_ADDENDUM: 'FreeForm Addendum Cannot be Blank',

  'COMMON.VALIDATION.MISSING_REQUIRED_FIELD': 'Invalid user information. Please try again.',
  'COMMON.ACCESS_NOT_PERMITTED':
    'Insufficient user permission to complete this action.  Please contact your administrator.',
  'COMMON.ACCOUNT_NOT_FOUND':
    'There are no Account Transfer Debit/Credit Account numbers setup for you',
  'COMMON.DATA_NOT_AVAILABLE': 'No Data Found. Please modify criteria and try again.',

  DUPLICATE_TEMPLATE: 'Duplicate template not allowed',

  ERD_REPORT_TYPES_NOT_FOUND: 'No reports have been permitted',
  EXCEEDED_BATCH_ENTRY_LIMIT: 'Batch Entry Limit exceeded.',
  EXCESS_INVALID_ATTEMPTS:
    'Maximum attempts reached. User account locked. Please contact your administrator for assistance.',
  EXCESS_INVALID_LOGIN_ATTEMPTS:
    'Maximum attempts reached. User account locked. Please contact your administrator for assistance.',
  EXCESS_INVALID_SECURITY_QUESTION_ANSWERS_ATTEMPTS:
    'Maximum attempts reached. User account locked. Please contact your administrator for assistance.',
  EXPIRED_CODE: 'Code Expired. Please request a new code.',

  FILE_MORE_THAN_500_RECORDS: 'Invalid file. Maximum 500 records.',

  ID_MISMATCH:
    'Your request cannot be processed. Please contact your administrator or customer service.',
  INACTIVE_USER:
    'Your request cannot be processed. Please contact your administrator or customer service.',
  INVALID_ABA_NUMBER:
    'The Bank Code / Number entered does not match our directory. Verify your entry.',
  INVALID_CODE: 'Invalid code, please try again.',
  INVALID_CUSTOMER:
    'Invalid login credential. Please contact your administrator or customer service.',
  INVALID_DATE_ENTERED: 'The From Date is past the To Date. Please update your date range.',
  INVALID_DEFAULT_CONTACT: 'There is not default contact selected.',
  INVALID_SECURITY_KEY: 'Invalid Login Key, please try again or request a new Key',
  INVALID_USER: 'Invalid login credential. Please contact your administrator or customer service.',
  INVALID_USER_EMAIL: 'No user email contact on file. Please contact your administrator.',
  INVALID_USER_PASSWORD:
    'Invalid login credential. Please try again or use Forgot Password link for assistance.',
  INVALID_USER_TEMP_PASSWORD:
    'Invalid login credential. Please try again or contact your administrator for assistance.',

  'IMAGING.CONFIG_PROVIDER_NOT_CONFIGURED':
    'Check Image is currently unavailable. Please try again later.',
  'IMAGING.RESP_IMAGE_RETRIEVAL_ERROR':
    'Check Image is currently unavailable. Please try again later.',
  'IMAGING.RESPONSE_3RDPARTY_IMAGING_SYSTEM_DOWN':
    'Check Image is currently unavailable. Please try again later.',

  IR_ERROR:
    'System error, please try back later. If problem persists, contact your administrator.',

  MISSED_CUTOFF: 'Disposition Action failed to complete as it is past the cut off time.',
  MISSING_RETURN_REASON: 'Please select a Reason.',

  NO_ACTION_TAKEN: 'No actions were taken.',
  NO_EMAIL_ID:
    'Insufficient information to support this request. Please contact your administrator for assistance.',
  NO_POSITIVE_PAY_ACCOUNTS_FOUND: 'No positive pay accounts found for the current user',
  NO_SECURITY_CONTACT: 'At least one Security Contact has to be set for this User.',
  NO_SECURITY_QUESTIONS:
    'Insufficient information to support this request. Please contact your administrator for assistance.',
  NO_STATEMENT_ACCOUNTS_FOUND: 'There are no Statement Account numbers setup for you.',
  NoCutoffsDefinedException:
    'Cut off not set for this bank. Please contact your administrator for assistance.',

  PASSWORD_IS_NOT_VALID: 'Current Password is not valid',
  PASSWORD_USED_TOO_RECENTLY:
    'Password was recently used and cannot be reused at this time. Please create a new one.',

  SECURITY_QUESTION_ANSWERS_INVALID: 'Invalid response. Please try again',
  STATEMENTS_NOT_FOUND: 'No statements found matching your request.',
  STATEMENT_IMAGE_NOT_FOUND:
    'System error, please try back later. If problem persists, contact your administrator.',
  'STOP_PAY.NO_MATCHING_RECORD_FOUND': 'No matching records found',

  TEMPORARY_PASSWORD_EXPIRED: 'Temporary Password no longer valid, please restart your request.',
  TEMPORARY_PASSWORD_USED: 'Temporary Password no longer valid, please restart your request.',
  'TRANSFER.EARLY_THAN_NEXTBUSINESS_DAY': 'Transfer earlier than next business day',
  'TRANSFER.MAX_DAILY_AMOUNT_EXCEEDED': 'Maximum daily amount exceeded',
  'TRANSFER.MAX_TRANSACTION_AMOUNT_EXCEEDED': 'Maximum transfer amount exceeded',

  'TRANSFER.INSUFFICIENT_FUNDS': 'Insufficient Funds',
  'TRANSFER.VALIDATION.CREDIT_ACCOUNT': 'Credit account not valid.',
  'TRANSFER.VALIDATION.DEBIT_ACCOUNT': 'Debit account not valid.',

  USER_ADMIN_lOCKED: 'User account locked. Please contact your administrator or customer service.',
  USER_INACTIVITY: 'User account locked. Please contact your administrator or customer service.',
  USER_LOCKED:
    'Your request cannot be processed. Please contact your administrator or customer service.',
  USER_NOT_ENABLED:
    'Your request cannot be processed. Please contact your administrator or customer service.'
};
